import { AiOutlineHome /* AiOutlineLineChart*/ } from "react-icons/ai";
import { BiBot } from "react-icons/bi";
import {
    MdOutlineAdminPanelSettings,
    MdOutlineContactSupport,
    MdOutlineDashboardCustomize,
} from "react-icons/md";
import { IoIosRocket } from "react-icons/io";
import { BiLock, BiImageAdd } from "react-icons/bi";
import { RiMoneyDollarBoxLine, RiUserSettingsLine } from "react-icons/ri";
import { GiMagnifyingGlass } from "react-icons/gi";
import { GoLaw } from "react-icons/go";

import {
    FaMicrophoneAlt,
    FaYoutube,
    FaDiscord,
    FaProjectDiagram,
} from "react-icons/fa";
import { RiAdvertisementLine } from "react-icons/ri";
import {
    BsTelegram,
    BsSafe,
    BsFillDice6Fill,
    BsClockHistory,
} from "react-icons/bs";
import { ReactComponent as TelegramSvg } from "../assets/images/home/white-telegram.svg";
import { ReactComponent as InstagramSvg } from "../assets/images/home/white-instagram.svg";
// import { ReactComponent as YouTubeSvg } from "../assets/images/home/white-youtube.svg";
// import { ReactComponent as FacebookSvg } from "../assets/images/home/white-facebook.svg";
import { ReactComponent as TwitterSvg } from "../assets/images/home/white-twitter.svg";
import {
    HiOutlineHome,
    HiOutlineSpeakerphone,
    HiOutlineUserGroup,
} from "react-icons/hi";
import {
    // TbChecklist,
    TbCloudLock,
    TbLockAccess,
    TbRocket,
} from "react-icons/tb";
// import { SiKnown } from "react-icons/si";
import { CgProfile } from "react-icons/cg";

export const ROUTE_LISTS = [
    {
        icon: <AiOutlineHome className="icon" />,
        title: "Homepage",
        link: "/",
    },
    // {
    //     icon: <AiOutlineLineChart className="icon" />,
    //     title: "DeFi Exchange",
    //     link: "/defi-exchange",
    // },
    // {
    // icon: <MdOutlineSell className="icon" />,
    // title: "Private Sale",
    // link: "/privateSale",
    // },
    // {
    //     icon: <GiNinjaMask className="icon" />,
    //     title: "Stealth Launch",
    //     nested: true,
    //     children: [
    //         {
    //             title: "Create Stealth",
    //             link: "/create-stealth",
    //         },
    //         {
    //             title: "Dashboard",
    //             link: "/stealth-dashboard",
    //         },
    //         {
    //             title: "Manage Stealth",
    //             link: "/manage-stealth",
    //         },
    //     ],
    // },
    {
        icon: <IoIosRocket className="icon" />,
        title: "Launchpad",
        nested: true,
        children: [
            {
                title: "Create Launchpad",
                link: "/create-launchpad",
            },
            {
                title: "Launchpad Dashboard",
                link: "/launchpad",
            },
            {
                title: "Manage Presale",
                link: "/manage-presale",
            },
        ],
    },
    {
        icon: <BiLock className="icon" />,
        title: "Lockers",
        nested: true,
        children: [
            {
                title: "Create Token Locker",
                link: "/create-locker",
            },
            {
                title: "View Token Lockers",
                link: "/token-lockers",
            },
            // {
            //     title: "Create Liquidity Locker",
            //     link: "/create-liquidity",
            // },
            {
                title: "Launchpad Lockers",
                link: "/lock-liquidity",
            },
        ],
    },
    {
        icon: <BsFillDice6Fill className="icon" />,
        title: "Games",
        nested: true,
        children: [
            {
                icon: <BsClockHistory className="icon" />,
                title: "Intense",
                link: "/intense",
            },
        ],
    },
    {
        icon: <RiMoneyDollarBoxLine className="icon" />,
        title: "Stake",
        link: "/stake",
    },
    {
        icon: <GiMagnifyingGlass className="icon" />,
        title: "Scan",
        link: "/scan",
    },
    {
        icon: <BiImageAdd className="icon" />,
        title: "NFT Mint",
        link: "/mint",
    },
    {
        icon: <FaMicrophoneAlt className="icon" />,
        title: "Lounge",
        link: "https://t.me/TitanTalks",
        external: true,
    },
    {
        icon: <BsSafe className="icon" />,
        title: "Audit/KYC",
        link: "/submit-document",
    },
    {
        icon: <BsTelegram className="icon" />,
        title: "Community",
        link: "https://t.me/KadidoCommunity",
        external: true,
    },
    {
        icon: <RiAdvertisementLine className="icon" />,
        title: "Advertise",
        nested: true,
        children: [
            {
                icon: <MdOutlineContactSupport className="icon" />,
                title: "Book an AMA",
                link: "https://t.me/KadidoCommunity",
                external: true,
            },
            {
                icon: <BiBot className="icon" />,
                title: "Free Price Bot",
                link: "https://t.me/KadidoCommunity",
                external: true,
            },
        ],
    },
    {
        icon: <GoLaw className="icon" />,
        title: "Public Documents",
        nested: true,
        children: [
            // {
            //     title: "Terms and Contitions",
            //     link: "/terms-conditions",
            // },
            // {
            //     title: "Privacy and Policy",
            //     link: "/privacy-policy",
            // },
            {
                title: "Whitepaper",
                link: "https://docs.google.com/presentation/d/15DYsEFvaysAFVgxTggOVBItdDFuY134W/edit?usp=sharing&ouid=113063085471049116357&rtpof=true&sd=true",
                external: true,
            },
            {
                title: "KYC",
                link: "https://Kadido.com",
                external: true,
            },
            {
                title: "Audit",
                link: "https://Kadido.com",
                external: true,
            },
        ],
    },
];

export const LANDING_ROUTE_LISTS = [
    {
        icon: <HiOutlineHome className="text-[20px] mr-1" />,
        title: "Home",
        link: "/",
    },
    {
        title: "Launchpad",
        nested: true,
        children: [
            {
                title: "New Presale",
                icon: <TbRocket className="size-3 hover:stroke-kadGrSt" />,
                subtitle: "Launch your presale here",
                link: "/create-launchpad",
            },
            {
                title: "All Presales",
                icon: (
                    <MdOutlineDashboardCustomize className="size-3 hover:fill-kadGrSt" />
                ),
                subtitle: "Explore new ideas",
                link: "/launchpad",
            },
            {
                title: "Your Presale",
                icon: (
                    <MdOutlineAdminPanelSettings className="size-3 hover:fill-kadGrSt" />
                ),
                subtitle: "Manage your presale",
                link: "/manage-presale",
            },
            {
                title: "LP Lockers",
                subtitle: "LP tokens for presales",
                icon: (
                    <FaProjectDiagram className="size-3 hover:fill-kadGrSt" />
                ),
                link: "/lock-liquidity",
            },
            {
                title: "New Token Locker",
                subtitle: "Create locker to secure",
                icon: <TbLockAccess className="size-3 hover:stroke-kadGrSt" />,
                link: "/create-locker",
            },
            {
                title: "Token Lockers",
                subtitle: "Explore Token Lockers",
                icon: <TbCloudLock className="size-3 hover:stroke-kadGrSt" />,
                link: "/token-lockers",
            },
        ],
    },
    // {
    //     title: "Lockers",
    //     nested: true,
    //     children: [
    //         {
    //             title: "LP Lockers",
    //             subtitle: "LP tokens for presales",
    //             icon: (
    //                 <FaProjectDiagram className="size-3 hover:fill-kadGrSt" />
    //             ),
    //             link: "/lock-liquidity",
    //         },
    //         {
    //             title: "New Token Locker",
    //             subtitle: "Create locker to secure",
    //             icon: <TbLockAccess className="size-3 hover:stroke-kadGrSt" />,
    //             link: "/create-locker",
    //         },
    //         {
    //             title: "Token Lockers",
    //             subtitle: "Explore Token Lockers",
    //             icon: <TbCloudLock className="size-3 hover:stroke-kadGrSt" />,
    //             link: "/token-lockers",
    //         },
    //     ],
    // },
    // {
    //     title: "Docs",
    //     nested: true,
    //     children: [
    //         // {
    //         //     title: "Terms & Contitions",
    //         //     icon: <FaBalanceScale className="size-3 hover:fill-kadGrSt" />,
    //         //     link: "/terms-conditions",
    //         // },
    //         // {
    //         //     title: "Privacy & Policy",
    //         //     icon: (
    //         //         <SiGnuprivacyguard className="size-3 hover:fill-kadGrSt" />
    //         //     ),
    //         //     link: "/privacy-policy",
    //         // },
    //         {
    //             title: "Whitepaper",
    //             icon: <IoMdPaper className="size-3 hover:fill-kadGrSt" />,
    //             link: "Kadido.com",
    //             external: true,
    //         },
    //         {
    //             title: "KYC",
    //             icon: <SiKnown className="size-3 hover:fill-kadGrSt" />,
    //             link: "https://Kadido.com/",
    //             external: true,
    //         },
    //         {
    //             title: "Audit",
    //             icon: <TbChecklist className="size-3 hover:stroke-kadGrSt" />,
    //             link: "https://Kadido.com",
    //             external: true,
    //         },
    //     ],
    // },
    {
        title: "Followers",
        link: "/profile",
        search: "&tab=followers",
    },
    {
        title: "Social",
        nested: true,
        children: [
            {
                title: "News Feed",
                icon: (
                    <HiOutlineSpeakerphone className="size-3 hover:stroke-kadGrSt" />
                ),
                link: "/feeds/activity",
            },
            {
                title: "Followers",
                icon: (
                    <HiOutlineUserGroup className="size-3 hover:stroke-kadGrSt" />
                ),
                link: "/privacy-policy",
            },
            {
                title: "Profile",
                icon: <CgProfile className="size-3 hover:text-kadGrSt" />,
                link: "/profile",
            },
            {
                title: "Settings",
                icon: (
                    <RiUserSettingsLine className="size-3 hover:fill-kadGrSt" />
                ),
                link: "/profile/settings",
            },
        ],
    },
];

export const getCurrentPageTitle = (location) => {
    const curPath = location.pathname;
    for (let item of ROUTE_LISTS) {
        if (curPath === item.link) {
            return item.title;
        }
        if (item.children?.length) {
            for (let child of item.children) {
                if (curPath === child.link) {
                    return child.title;
                }
            }
        }
    }
    return "";
};

export const SOCIAL_LINKS = (clsName) => {
    return [
        {
            title: "Discord",
            icon: <FaDiscord className={clsName} />,
            link: "https://discord.gg/Kadido",
        },
        {
            title: "Telegram",
            icon: <TelegramSvg className={clsName} />,
            link: "https://t.me/Kadido",
        },
        {
            title: "Instagram",
            icon: <InstagramSvg className={clsName} />,
            link: "https://www.instagram.com/Kadido/",
        },
        {
            title: "Twitter",
            icon: <TwitterSvg className={clsName} />,
            link: "https://twitter.com/Kadido",
        },
        {
            title: "YouTube",
            icon: <FaYoutube className={clsName} />,
            link: "https://www.youtube.com/channel/Kadido",
        },
    ];
};
